import * as types from './actionTypes';  
import fileUploadForPlannerApi from '../api/fileUploadForPlannerApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function fileUploadRes(data) {  
  return {
    type: types.UPLOAD_PLANNER_FILE_RES, 
    data
  };
}

export function uploadPlannerFile(file) {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      fileUploadForPlannerApi.fileUpload(file).then(data => {
        dispatch(fileUploadRes(data));
        dispatch(fileUploadRes(null));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
  
}